import React from'react';import PropTypes from'prop-types';import {Helmet as Helmet$2}from'react-helmet';import {useIntl}from'react-intl';var Helmet = function Helmet(_ref) {
  var title = _ref.title;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Helmet$2, {
    titleTemplate: intl.formatMessage({
      id: 'shared.page.titleTemplate'
    }),
    defaultTitle: intl.formatMessage({
      id: 'shared.page.defaultTitle'
    })
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("html", {
    lang: intl.locale
  }));
};
process.env.NODE_ENV !== "production" ? Helmet.propTypes = {
  title: PropTypes.string
} : void 0;
Helmet.defaultProps = {
  title: undefined
};
var Helmet$1 = Helmet;export{Helmet$1 as default};